import {RequestMethod} from '@angular/http';
import {
  UNREACHABLE_SERVICE_ERROR_CODE,
  NETWORK_SERVICE_ERROR_CODE,
  INTERNAL_SERVICE_ERROR_CODE,
} from '../../model/errors/service-error.model';

export interface RetryHandler {
  handle(error: any, method: RequestMethod, retryCount: number, retryConfig: any): number
}
export class DefaultRetryHandler implements RetryHandler {
  public handle(error: any, method: RequestMethod, retryCount: number, retryConfig: any): number {
    if (!error) {
      throw Error('Unknown http error');
    }
    const status: number = this._isTimeout(error) ? NETWORK_SERVICE_ERROR_CODE : error.status;
    switch (status) {
      case UNREACHABLE_SERVICE_ERROR_CODE:
      case NETWORK_SERVICE_ERROR_CODE:
      case INTERNAL_SERVICE_ERROR_CODE:
        if (retryCount > retryConfig.maxRetries) {
          throw error;
        }
        break;
      default:
        // no retrying for other codes
        throw error;
    }
    return retryCount;
  };

  private _isTimeout(error): boolean {
    return error.message && error.message.toUpperCase().indexOf('TIMEOUT') !== -1;
  }
};



// WEBPACK FOOTER //
// ./src/main/webapp/stay-mgmt/app/api/daos/handlers/retry.handlers.ts